// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TextFormattingMenu__container-cdeaee {
  display: inline-flex;
  align-items: center;
  padding: 6px;
  box-sizing: border-box;
  background-color: var(--base-10);
  border: 1px solid var(--base-30);
  box-shadow: var(--box-shadow-popover);
  border-radius: 8px;
  z-index: 1;
}`, "",{"version":3,"sources":["webpack://./src/components/TextFormattingInput/TextFormattingMenu/TextFormattingMenu.styles.m.css"],"names":[],"mappings":"AAAA;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,sBAAA;EACA,gCAAA;EACA,gCAAA;EACA,qCAAA;EACA,kBAAA;EACA,UAAA;AACF","sourcesContent":[".container {\n  display: inline-flex;\n  align-items: center;\n  padding: 6px;\n  box-sizing: border-box;\n  background-color: var(--base-10);\n  border: 1px solid var(--base-30);\n  box-shadow: var(--box-shadow-popover);\n  border-radius: 8px;\n  z-index: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `TextFormattingMenu__container-cdeaee`
};
module.exports = ___CSS_LOADER_EXPORT___;
